export default "__VITE_ASSET__BrQkJqcu__"